import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { ModalNotification } from '@app/components';

export const InactiveAccountNotification: FC = () => (
  <ModalNotification
    type="error"
    modalNotifications={{
      error: {
        type: 'error',
        header: (
          <FormattedMessage
            id="inactiveAccount.title"
            defaultMessage="Your borrowing account is inactive"
          />
        ),
        children: (
          <FormattedMessage
            id="inactiveAccount.contactLibrary"
            defaultMessage="Please contact the library to reactivate your account."
          />
        ),
      },
    }}
  />
);
